import { render, staticRenderFns } from "./SettleLawsuit.vue?vue&type=template&id=8d57dd2a&scoped=true"
import script from "./SettleLawsuit.vue?vue&type=script&lang=js"
export * from "./SettleLawsuit.vue?vue&type=script&lang=js"
import style0 from "./SettleLawsuit.vue?vue&type=style&index=0&id=8d57dd2a&prod&scoped=true&lang=css"
import style1 from "./SettleLawsuit.vue?vue&type=style&index=1&id=8d57dd2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d57dd2a",
  null
  
)

export default component.exports